import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Note = makeShortcode("Note");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <Note mdxType="Note">
      <p>{`For organizations using SSO, access to GraphOS is exclusively managed through your IdP.
Any `}<a parentName="p" {...{
          "href": "/graphos/org/members/#inviting-members"
        }}>{`invitation links`}</a>{` created before SSO setup will be automatically revoked and you won't be able to create new invitation links once SSO is enabled.
To give team members access, assign them to the GraphOS application in your IdP.`}</p>
    </Note>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      